module.exports = __webpack_public_path__ + "img/addfirsttimer-icon.49b6e8ef.svg";